import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, HostBinding, Input, Output, NgModule, ViewContainerRef, Directive, Optional, Self, HostListener } from '@angular/core';
import * as i2 from '@eui/components/eui-icon';
import { EuiIconModule, EuiIconSvgComponent, EuiIconComponent } from '@eui/components/eui-icon';
import { BaseDirective } from '@eui/components/shared/base';
export * from '@eui/components/shared/base';
import * as i1$1 from '@angular/forms';
import { NgModel } from '@angular/forms';

class EuiExpandContentComponent {
    constructor() {
        this._isCollapsed = false;
        this.expandLabel = '';
        this.collapseLabel = '';
        this.collapsed = new EventEmitter();
    }
    get cssClasses() {
        return [
            `eui-expand-content`,
            this.isCollapsed ? 'eui-expand-content--collapsed' : '',
        ].join(' ').trim();
    }
    get isCollapsed() { return this._isCollapsed; }
    set isCollapsed(value) { this._isCollapsed = coerceBooleanProperty(value); }
    onToggle() {
        this.isCollapsed = !this.isCollapsed;
        this.collapsed.emit(this.isCollapsed);
    }
}
/** @nocollapse */ EuiExpandContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiExpandContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ EuiExpandContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: EuiExpandContentComponent, selector: "eui-expand-content", inputs: { isCollapsed: "isCollapsed", expandLabel: "expandLabel", collapseLabel: "collapseLabel" }, outputs: { collapsed: "collapsed" }, host: { properties: { "class": "this.cssClasses" } }, ngImport: i0, template: "<div *ngIf=\"!isCollapsed\" class=\"eui-expand-content__body\">\n    <ng-content></ng-content>\n</div>\n<div class=\"eui-button__expand-trigger\" [class.eui-button__expand-trigger--collapsed]=\"isCollapsed\" role=\"document\" (click)=\"onToggle()\" aria-label=\"Expand / Collapse trigger\">\n    <button *ngIf=\"isCollapsed\" class=\"eui-button eui-button--expand-toggle\" aria-label=\"Expand\">\n        <span *ngIf=\"expandLabel\" class=\"eui-label eui-u-color-grey-dark eui-u-mr-xs\">{{expandLabel}}</span>\n        <eui-icon-svg icon=\"eui-chevron-down\"></eui-icon-svg>\n    </button>\n    <button *ngIf=\"!isCollapsed\" class=\"eui-button eui-button--expand-toggle\" aria-label=\"Collapse\">\n        <span *ngIf=\"collapseLabel\" class=\"eui-label eui-u-color-grey-dark eui-u-mr-xs\">{{collapseLabel}}</span>\n        <eui-icon-svg icon=\"eui-chevron-up\"></eui-icon-svg>\n    </button>\n</div>\n", styles: [".eui-expand-content{display:flex;flex-direction:column;position:relative;width:100%}.eui-expand-content__body{display:flex;padding-top:var(--eui-base-spacing-m);width:100%}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.EuiIconSvgComponent, selector: "eui-icon-svg, span[euiIconSvg], i[euiIconSvg]", inputs: ["icon", "size", "fillColor", "set", "ariaLabelledby", "role", "style", "iconUrl", "aria-label", "ariaHidden", "focusable", "isLoading"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiExpandContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'eui-expand-content', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<div *ngIf=\"!isCollapsed\" class=\"eui-expand-content__body\">\n    <ng-content></ng-content>\n</div>\n<div class=\"eui-button__expand-trigger\" [class.eui-button__expand-trigger--collapsed]=\"isCollapsed\" role=\"document\" (click)=\"onToggle()\" aria-label=\"Expand / Collapse trigger\">\n    <button *ngIf=\"isCollapsed\" class=\"eui-button eui-button--expand-toggle\" aria-label=\"Expand\">\n        <span *ngIf=\"expandLabel\" class=\"eui-label eui-u-color-grey-dark eui-u-mr-xs\">{{expandLabel}}</span>\n        <eui-icon-svg icon=\"eui-chevron-down\"></eui-icon-svg>\n    </button>\n    <button *ngIf=\"!isCollapsed\" class=\"eui-button eui-button--expand-toggle\" aria-label=\"Collapse\">\n        <span *ngIf=\"collapseLabel\" class=\"eui-label eui-u-color-grey-dark eui-u-mr-xs\">{{collapseLabel}}</span>\n        <eui-icon-svg icon=\"eui-chevron-up\"></eui-icon-svg>\n    </button>\n</div>\n", styles: [".eui-expand-content{display:flex;flex-direction:column;position:relative;width:100%}.eui-expand-content__body{display:flex;padding-top:var(--eui-base-spacing-m);width:100%}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { cssClasses: [{
                type: HostBinding,
                args: ['class']
            }], isCollapsed: [{
                type: Input
            }], expandLabel: [{
                type: Input
            }], collapseLabel: [{
                type: Input
            }], collapsed: [{
                type: Output
            }] } });
/* ***************************************** */
/* MODULE EXPORT */
/* ***************************************** */
class EuiExpandContentModule {
}
/** @nocollapse */ EuiExpandContentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiExpandContentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EuiExpandContentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: EuiExpandContentModule, declarations: [EuiExpandContentComponent], imports: [CommonModule,
        EuiIconModule], exports: [EuiExpandContentComponent] });
/** @nocollapse */ EuiExpandContentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiExpandContentModule, imports: [CommonModule,
        EuiIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiExpandContentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        EuiIconModule,
                    ],
                    declarations: [
                        EuiExpandContentComponent,
                    ],
                    exports: [
                        EuiExpandContentComponent,
                    ],
                }]
        }] });

class EuiCommonHeaderComponent {
    constructor() {
        this._isHighlighted = false;
        this._isCollapsed = false;
    }
    get cssClasses() {
        return [
            `eui-common-header`,
            this.isCollapsed ? 'eui-common-header--collapsed' : '',
        ].join(' ').trim();
    }
    get isHighlighted() { return this._isHighlighted; }
    set isHighlighted(value) { this._isHighlighted = coerceBooleanProperty(value); }
    get isCollapsed() { return this._isCollapsed; }
    set isCollapsed(value) { this._isCollapsed = coerceBooleanProperty(value); }
}
/** @nocollapse */ EuiCommonHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiCommonHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ EuiCommonHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: EuiCommonHeaderComponent, selector: "eui-common-header", inputs: { label: "label", subLabel: "subLabel", isHighlighted: "isHighlighted", isCollapsed: "isCollapsed" }, host: { properties: { "class": "this.cssClasses" } }, ngImport: i0, template: "<div class=\"eui-common-header__label\">\n    <div class=\"eui-common-header__label-text\" role=\"heading\" aria-level=\"1\" attr.aria-label=\"{{label}}\">{{label}}</div>\n    <div class=\"eui-common-header__actions\">\n        <ng-content></ng-content>\n    </div>\n</div>\n<div *ngIf=\"subLabel\" class=\"eui-common-header__sub-label\" role=\"heading\" aria-level=\"2\" [class.eui-common-header__sub-label--collapsed]=\"isCollapsed\" attr.aria-label=\"{{subLabel}}\">\n    <div class=\"eui-common-header__sub-label-text\" >{{subLabel}}</div>\n</div>\n", styles: [".eui-common-header{display:flex;flex-direction:column;width:100%}.eui-common-header__label{align-items:center;display:flex;font-size:var(--eui-base-font-size-3xl);justify-content:space-between;width:100%}.eui-common-header__label-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.eui-common-header__sub-label{align-items:center;color:var(--eui-base-color-grey-90);display:flex;font-size:var(--eui-base-font-size-xl);justify-content:space-between;padding-top:var(--eui-base-spacing-2xs);width:100%}.eui-common-header__sub-label-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.eui-common-header__actions{display:flex;flex:1 0 auto;justify-content:flex-end;margin-left:var(--eui-base-spacing-s)}.eui-common-header__body{display:flex;padding:var(--eui-base-spacing-m);transition:all .5s;width:100%}.eui-common-header__expand-trigger{bottom:calc(-1 * var(--eui-base-spacing-xs));left:0;position:absolute;text-align:center;width:100%}.eui-common-header__expand-trigger-toggle{background:var(--eui-base-color-white);border-bottom:2px solid #9a9a9a;border-radius:50%;cursor:pointer;font-size:1.25rem;padding:.125rem .5rem}.eui-common-header__expand-trigger-toggle:hover,.eui-common-header__expand-trigger-toggle:focus{color:var(--eui-base-color-primary-100);box-shadow:var(--eui-base-shadow-2)}@media screen and (max-width: 767px){.eui-common-header__label-text,.eui-common-header__sub-label-text{white-space:normal!important}}@media screen and (min-width: 768px) and (max-width: 995px){.eui-common-header__label-text,.eui-common-header__sub-label-text{white-space:normal!important}}.eui-common-header--collapsed .eui-common-header__body{transition:all .5s}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiCommonHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'eui-common-header', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<div class=\"eui-common-header__label\">\n    <div class=\"eui-common-header__label-text\" role=\"heading\" aria-level=\"1\" attr.aria-label=\"{{label}}\">{{label}}</div>\n    <div class=\"eui-common-header__actions\">\n        <ng-content></ng-content>\n    </div>\n</div>\n<div *ngIf=\"subLabel\" class=\"eui-common-header__sub-label\" role=\"heading\" aria-level=\"2\" [class.eui-common-header__sub-label--collapsed]=\"isCollapsed\" attr.aria-label=\"{{subLabel}}\">\n    <div class=\"eui-common-header__sub-label-text\" >{{subLabel}}</div>\n</div>\n", styles: [".eui-common-header{display:flex;flex-direction:column;width:100%}.eui-common-header__label{align-items:center;display:flex;font-size:var(--eui-base-font-size-3xl);justify-content:space-between;width:100%}.eui-common-header__label-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.eui-common-header__sub-label{align-items:center;color:var(--eui-base-color-grey-90);display:flex;font-size:var(--eui-base-font-size-xl);justify-content:space-between;padding-top:var(--eui-base-spacing-2xs);width:100%}.eui-common-header__sub-label-text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.eui-common-header__actions{display:flex;flex:1 0 auto;justify-content:flex-end;margin-left:var(--eui-base-spacing-s)}.eui-common-header__body{display:flex;padding:var(--eui-base-spacing-m);transition:all .5s;width:100%}.eui-common-header__expand-trigger{bottom:calc(-1 * var(--eui-base-spacing-xs));left:0;position:absolute;text-align:center;width:100%}.eui-common-header__expand-trigger-toggle{background:var(--eui-base-color-white);border-bottom:2px solid #9a9a9a;border-radius:50%;cursor:pointer;font-size:1.25rem;padding:.125rem .5rem}.eui-common-header__expand-trigger-toggle:hover,.eui-common-header__expand-trigger-toggle:focus{color:var(--eui-base-color-primary-100);box-shadow:var(--eui-base-shadow-2)}@media screen and (max-width: 767px){.eui-common-header__label-text,.eui-common-header__sub-label-text{white-space:normal!important}}@media screen and (min-width: 768px) and (max-width: 995px){.eui-common-header__label-text,.eui-common-header__sub-label-text{white-space:normal!important}}.eui-common-header--collapsed .eui-common-header__body{transition:all .5s}\n"] }]
        }], propDecorators: { cssClasses: [{
                type: HostBinding,
                args: ['class']
            }], label: [{
                type: Input
            }], subLabel: [{
                type: Input
            }], isHighlighted: [{
                type: Input
            }], isCollapsed: [{
                type: Input
            }] } });
/* ***************************************** */
/* MODULE EXPORT */
/* ***************************************** */
class EuiCommonHeaderModule {
}
/** @nocollapse */ EuiCommonHeaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiCommonHeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EuiCommonHeaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: EuiCommonHeaderModule, declarations: [EuiCommonHeaderComponent], imports: [CommonModule], exports: [EuiCommonHeaderComponent] });
/** @nocollapse */ EuiCommonHeaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiCommonHeaderModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiCommonHeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                    ],
                    declarations: [
                        EuiCommonHeaderComponent,
                    ],
                    exports: [
                        EuiCommonHeaderComponent,
                    ],
                }]
        }] });

class InputDirective extends BaseDirective {
    constructor(_elementRef, _renderer, control, injector) {
        super();
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this.control = control;
        this.injector = injector;
        this._viewContainerRef = this.injector.get(ViewContainerRef);
    }
    get disabled() {
        return this._disabled ? true : null;
    }
    set disabled(state) {
        // in case it's controlled by NgControl override
        this._disabled = coerceBooleanProperty(state);
        // set BaseDirective Attribute
        super.euiDisabled = this._disabled;
    }
    get readonly() {
        return this._elementRef.nativeElement.attributes.readonly || null;
    }
    set readonly(state) {
        this._readonly = coerceBooleanProperty(state);
        if (this._readonly) {
            this._renderer.setAttribute(this._elementRef.nativeElement, 'readonly', 'true');
        }
        else {
            this._renderer.removeAttribute(this._elementRef.nativeElement, 'readonly');
        }
    }
    get placeholder() {
        return this.getPlaceholderAttribute();
    }
    set placeholder(value) {
        this.setPlaceholderAttribute(value?.toString());
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this.setIdAttribute(value);
    }
    ngOnInit() {
        if (this.control) {
            this.disabled = this.control.disabled;
            // subscribe to NG control status changes to adjust inputs
            this._statusListener = this.control.statusChanges.subscribe(status => {
                super.euiDanger = status === 'INVALID' && this.control.touched;
                this.disabled = status === 'DISABLED' && this.control.disabled;
            });
        }
    }
    ngOnDestroy() {
        if (this._statusListener) {
            this._statusListener.unsubscribe();
        }
    }
    ngOnChanges(changes) {
        // TODO: the check below to be removed and replaced by usage of mixins at EuiNumber and EuiText
        if (changes['euiClearable']) {
            // get type of the control
            const type = this._elementRef.nativeElement.type;
            if (coerceBooleanProperty(changes['euiClearable'].currentValue)) {
                // check if type is not euiInputNumber or euiInputText, reset and throw error
                if (type !== 'eui-number' && type !== 'text') {
                    this.euiClearable = true;
                    throw new Error('euiClearable is only allowed in euiInputNumber or euiInputText');
                }
                // create dynamically the icon
                this.createClearableIcon();
                // wrap them all at an eui-u-flex class
                this.createFlexWrapper();
                this._renderer.appendChild(this._euiUFlexWrapper, this._clearableIcon.location.nativeElement);
            }
            else if (this._clearableIcon) {
                this.removeClearableIcon();
                if (!this.euiLoading) {
                    this.removeFlexWrapper();
                }
            }
        }
        if (changes['euiLoading']) {
            if (coerceBooleanProperty(changes['euiLoading'].currentValue)) {
                const type = this._elementRef.nativeElement.type;
                // check if type is not euiInputNumber or euiInputText, reset and throw error
                if (type !== 'eui-number' && type !== 'text') {
                    this.euiClearable = true;
                    throw new Error('euiClearable is only allowed in euiInputNumber or euiInputText');
                }
                // wrap them all in a eui-u-flex class
                this.createFlexWrapper();
                // create dynamically the icon
                this.createLoadingIcon();
            }
            else if (this._loadingIcon) {
                this.removeLoadingIcon();
                if (!this.euiClearable) {
                    this.removeFlexWrapper();
                }
            }
        }
        if (changes['readonly']) {
            if (changes['readonly'].currentValue === false && (this.euiClearable || this.euiLoading)) {
                // create wrapper
                this.createFlexWrapper();
                if (this.euiClearable) {
                    // create dynamically the icon
                    this.createClearableIcon();
                    this._renderer.appendChild(this._euiUFlexWrapper, this._clearableIcon.location.nativeElement);
                }
                else {
                    // create dynamically the icon
                    this.createLoadingIcon();
                    this._renderer.appendChild(this._euiUFlexWrapper, this._loadingIcon.location.nativeElement);
                }
            }
            if (changes['readonly'].currentValue === true) {
                this.removeLoadingIcon();
                this.removeClearableIcon();
                this.removeFlexWrapper();
            }
        }
        if (changes['disabled'] || changes['euiDisabled']) {
            if (this._clearableIcon) {
                const disabled = changes['disabled']?.currentValue || changes['euiDisabled']?.currentValue;
                disabled ?
                    this._renderer.setStyle(this._clearableIcon.location.nativeElement, 'pointer-events', 'none') :
                    this._renderer.removeStyle(this._clearableIcon.location.nativeElement, 'pointer-events');
            }
        }
    }
    getPlaceholderAttribute() {
        // in readonly memorize placeholder value and remove placeholder. The reason is that CSS style for readonly
        // cannot hide the placeholder text
        if (this._elementRef.nativeElement.attributes['readonly']) {
            if (!this._placeholder) {
                this.setPlaceholderAttribute(this._elementRef.nativeElement.placeholder);
            }
            this._elementRef.nativeElement.placeholder = '';
            return undefined;
        }
        // keep placeholder's value
        this._placeholder = this._elementRef.nativeElement.placeholder || this._placeholder;
        return this._placeholder;
    }
    setPlaceholderAttribute(value) {
        if (!value) {
            this._renderer.removeAttribute(this._elementRef.nativeElement, 'placeholder');
        }
        else {
            this._renderer.setAttribute(this._elementRef.nativeElement, 'placeholder', value);
        }
        this._placeholder = value;
    }
    setIdAttribute(value = null) {
        this._id = value ? value : `${this._elementRef.nativeElement.type}_${Math.floor(Math.random() * 1000000)}`;
    }
    onKeyUpAndModelChange(value) {
        if (this.euiClearable) {
            const visibility = value?.toString().length > 0 ? 'visible' : 'hidden';
            this._renderer.setStyle(this._clearableIcon.location.nativeElement, 'visibility', visibility);
        }
    }
    onClearableClicked(event) {
        if (this._disabled || this.euiDisabled) {
            return;
        }
        if (this.control) {
            this.control.reset();
        }
        else {
            const inputEvent = new InputEvent('input', { data: null });
            this._elementRef.nativeElement.value = null;
            this._elementRef.nativeElement.dispatchEvent(inputEvent);
        }
        const clearEvent = new InputEvent('clear');
        this._elementRef.nativeElement.dispatchEvent(clearEvent);
    }
    createFlexWrapper() {
        if (!this._euiUFlexWrapper) {
            this._euiUFlexWrapper = this._renderer.createElement('div');
            this._renderer.addClass(this._euiUFlexWrapper, 'eui-u-flex');
            this._renderer.setStyle(this._euiUFlexWrapper, 'position', 'relative');
            this._renderer.insertBefore(this._elementRef.nativeElement.parentElement, this._euiUFlexWrapper, this._elementRef.nativeElement);
            this._renderer.appendChild(this._euiUFlexWrapper, this._elementRef.nativeElement);
        }
    }
    /**
     * removes the flexWrapper while keeping the input element intact
     * @private
     */
    removeFlexWrapper() {
        if (this._euiUFlexWrapper) {
            this._renderer.insertBefore(this._euiUFlexWrapper.parentElement, this._elementRef.nativeElement, this._euiUFlexWrapper);
            this._renderer.removeChild(this._euiUFlexWrapper.parentElement, this._euiUFlexWrapper);
            this._euiUFlexWrapper.remove();
            this._euiUFlexWrapper = null;
        }
    }
    /**
     * detach the Clearable icon from the view
     * @private
     */
    removeClearableIcon() {
        if (this._clearableIcon) {
            const index = this._viewContainerRef.indexOf(this._clearableIcon.hostView);
            this._viewContainerRef.detach(index);
            this._clearableIcon = null;
        }
    }
    /**
     * creates the Clearable icon component
     * @private
     */
    createClearableIcon() {
        if (!this._clearableIcon) {
            this._clearableIcon = this._viewContainerRef.createComponent(EuiIconSvgComponent);
            this._clearableIcon.instance.set = 'eui';
            this._clearableIcon.instance.icon = 'eui-close';
            this._renderer.addClass(this._clearableIcon.location.nativeElement, 'eui-input-text--clearable-icon');
            this._renderer.listen(this._clearableIcon.location.nativeElement, 'click', this.onClearableClicked.bind(this));
            const value = this.control ?
                this.control instanceof NgModel ? this.control.model?.toString() : this.control.value?.toString() :
                this._elementRef.nativeElement.value;
            this._renderer.setStyle(this._clearableIcon.location.nativeElement, 'visibility', value?.length > 0 ? 'visible' : 'hidden');
            this.euiDisabled ?
                this._renderer.setStyle(this._clearableIcon.location.nativeElement, 'pointer-events', 'none') :
                this._renderer.removeStyle(this._clearableIcon.location.nativeElement, 'pointer-events');
        }
    }
    /**
     * creates the loading icon component
     * @private
     */
    createLoadingIcon() {
        if (!this._loadingIcon) {
            this._loadingIcon = this._viewContainerRef.createComponent(EuiIconComponent);
            this._loadingIcon.instance.styleClass = 'eui-input-text--loading-icon';
            this._loadingIcon.instance.ariaLabel = 'XXXXX';
            this._renderer.appendChild(this._euiUFlexWrapper, this._loadingIcon.location.nativeElement);
        }
    }
    /**
     * removes the loading icon component
     * @private
     */
    removeLoadingIcon() {
        if (this._loadingIcon) {
            const index = this._viewContainerRef.indexOf(this._loadingIcon.hostView);
            this._viewContainerRef.detach(index);
            this._loadingIcon = null;
        }
    }
}
/** @nocollapse */ InputDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: InputDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1$1.NgControl, optional: true, self: true }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ InputDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: InputDirective, selector: "input[euiInput]", inputs: { disabled: "disabled", readonly: "readonly", placeholder: "placeholder", id: "id" }, host: { listeners: { "input": "onKeyUpAndModelChange($event.target.value)", "ngModelChange": "onKeyUpAndModelChange($event)" }, properties: { "attr.disabled": "this.disabled", "attr.readonly": "this.readonly", "attr.placeholder": "this.placeholder", "attr.id": "this.id" } }, usesInheritance: true, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: InputDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: 'input[euiInput]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1$1.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.Injector }]; }, propDecorators: { disabled: [{
                type: HostBinding,
                args: ['attr.disabled']
            }, {
                type: Input
            }], readonly: [{
                type: HostBinding,
                args: ['attr.readonly']
            }, {
                type: Input
            }], placeholder: [{
                type: HostBinding,
                args: ['attr.placeholder']
            }, {
                type: Input
            }], id: [{
                type: HostBinding,
                args: ['attr.id']
            }, {
                type: Input
            }], onKeyUpAndModelChange: [{
                type: HostListener,
                args: ['input', ['$event.target.value']]
            }, {
                type: HostListener,
                args: ['ngModelChange', ['$event']]
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { EuiCommonHeaderComponent, EuiCommonHeaderModule, EuiExpandContentComponent, EuiExpandContentModule, InputDirective };
